"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isActive = exports.getStatus = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _constants = require("../../constants");

var _generalUtils = require("./general-utils");

var _banking = require("../banking");

/**
 * Get the status of the entity
 * NOTE: does not support `MORTG`
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {string}                   The status [ACTIVE,INACTIVE]
 */
var getStatus = function getStatus(marketplaceEntity) {
  return (0, _generalUtils.callSelectorByProductType)(marketplaceEntity, (0, _defineProperty2.default)({}, _constants.PRODUCT_TYPES.BANKING, _banking.getDisplayStatus), function (entity) {
    return (0, _get2.default)(entity, 'status');
  });
};
/**
 * Get the active status of the entity
 * Returns `true` if entity is active
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {boolean}
 */


exports.getStatus = getStatus;

var isActive = function isActive(marketplaceEntity) {
  return getStatus(marketplaceEntity) === _constants.STATUSES.ACTIVE;
};

exports.isActive = isActive;